// 评估项目
import pgxmRoutes from '@/features/jxxf/pg/pgxm/pgxm.routes.js';

// 评估仪器
import pgyqRoutes from '@/features/jxxf/pg/pgyqgl/pgyq.routes.js';

// 人员签到信息
import ryqdxxRoutes from '@/features/jxxf/pg/ryqdxx/ryqdxx.routes.js';

// 问题列表管理
import wtlbRoutes from '@/features/jxxf/pg/wtlb/wtlb.routes.js';

// 报告管理
import bgglRoutes from '@/features/jxxf/pg/bggl/bggl.routes.js';

const FEATURES_ROUTES = [pgxmRoutes, pgyqRoutes, ryqdxxRoutes, wtlbRoutes, bgglRoutes];

const pgRoutes = {
  path: 'pg',
  name: 'jxxfPg',
  component: { template: '<router-view></router-view>' },
  children: [...FEATURES_ROUTES]
};

export default pgRoutes;
